import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const BookOpen14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_35)'>
      <path
        d='M11.1821 8.7276C11.5839 8.62714 11.8282 8.21994 11.7278 7.81809C11.6273 7.41624 11.2201 7.17192 10.8183 7.27238L8.81828 7.77238C8.41643 7.87285 8.17211 8.28005 8.27257 8.68189C8.37303 9.08374 8.78023 9.32806 9.18208 9.2276L11.1821 8.7276Z'
        fill='currentColor'
      />
      <path
        d='M11.7278 4.81809C11.8282 5.21994 11.5839 5.62714 11.1821 5.7276L9.18208 6.2276C8.78023 6.32806 8.37303 6.08374 8.27257 5.68189C8.17211 5.28005 8.41643 4.87285 8.81828 4.77238L10.8183 4.27238C11.2201 4.17192 11.6273 4.41624 11.7278 4.81809Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.1819 0.772335C0.716035 0.655869 0.25 1.01974 0.25 1.49994V10.9999C0.25 11.3441 0.484223 11.6441 0.818098 11.7275L6.8181 13.2275C6.93753 13.2574 7.06247 13.2574 7.1819 13.2275L13.1819 11.7275C13.5158 11.6441 13.75 11.3441 13.75 10.9999V1.49994C13.75 1.01974 13.284 0.655869 12.8181 0.772335L7 2.22686L1.1819 0.772335ZM1.75 10.4144V2.46052L6.25 3.58552V11.5394L1.75 10.4144ZM7.75 11.5394L12.25 10.4144V2.46052L7.75 3.58552V11.5394Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_35'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

BookOpen14.displayName = 'BookOpen14';
export default BookOpen14;
